export default __webpack_public_path__ + "static/defaultAvatarLarge-e3ae0104d9132005b14c42a330f69fb5.png";